import { useEffect, useState } from "react";
import Nav from "@/components/site/Nav";
import AnnouncementBar, { getDismissKey } from "@/components/site/AnnouncementBar";
import Hero from "@/components/site/Hero";
import SponsorshipStrip from "@/components/site/SponsorshipStrip";
import About from "@/components/site/About";
import Programs from "@/components/site/Programs";
import TravelTeams from "@/components/site/TravelTeams";
import Testimonials from "@/components/site/Testimonials";
import Contact from "@/components/site/Contact";
import Footer from "@/components/site/Footer";

function computeBarVisible() {
  if (typeof window === "undefined") return true;
  return localStorage.getItem(getDismissKey()) !== "1";
}

export default function Landing() {
  const [barVisible, setBarVisible] = useState(computeBarVisible);

  // Sync across tabs + re-check when phase might have rolled over (once/minute)
  useEffect(() => {
    const onStorage = (e) => {
      if (e.key && e.key.startsWith("bba_announcement_dismissed_")) {
        setBarVisible(computeBarVisible());
      }
    };
    window.addEventListener("storage", onStorage);
    const id = setInterval(() => setBarVisible(computeBarVisible()), 60_000);
    return () => {
      window.removeEventListener("storage", onStorage);
      clearInterval(id);
    };
  }, []);

  return (
    <main className="bg-[#050B14] text-white min-h-screen font-body">
      {barVisible ? (
        <AnnouncementBar onDismiss={() => setBarVisible(false)} />
      ) : null}
      <Nav barVisible={barVisible} />
      <Hero />
      <SponsorshipStrip />
      <About />
      <Programs />
      <TravelTeams />
      <Testimonials />
      <Contact />
      <Footer />
    </main>
  );
}
